import { LabelType } from '@angular-slider/ngx-slider';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';

@Component({
  selector: 'shared-filter-panel-pace-offset',
  templateUrl: './filter-panel-pace-offset.component.html',
  styleUrls: ['./filter-panel-pace-offset.component.scss'],
  host: { class: 'filter-panel-pace-offset' },
})
export class SharedFilterPanelPaceOffsetComponent implements OnInit {
  @Input() paceOffset: Filter[] = [];
  @Output() paceOffsetChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  value = -100;
  highValue = 100;
  options = {
    floor: -100,
    ceil: 100,
    step: 5,
    showTicks: true,
    translate: (value: number, label: LabelType): string => {
      return value + '%';
    },
  };

  constructor() {}

  ngOnInit() {
    if (this.paceOffset?.length > 0) {
      const paceOffsetRangeArray = this.paceOffset[0]?.value.split(',').map((s: any) => Number(s.trim()));
      this.value = paceOffsetRangeArray[0] * 100;
      this.highValue = paceOffsetRangeArray[1] * 100;
    }
  }

  changeOffsetFilterRange(range: any) {
    this.paceOffset = [
      <Filter>{
        value: `${range.value / 100},${range.highValue / 100}`,
        displayName: 'Pace Offset - Low ' + range.value + '% - High ' + range.highValue + '%',
        type: 'paceOffset',
      },
    ];
  }

  closeFilterPanel() {
    this.paceOffsetChange.emit(this.paceOffset);
    this.close.emit();
  }

  clear() {
    this.paceOffset = [];
    this.paceOffsetChange.emit(this.paceOffset);
  }
}
